<template>
    <div>
        <div class="touch_panel" style="" ref="touchPanel">
            <div class="trans_target" ref="transTarget" style="">
                <div class="image_wrap" style="" v-for="each, i in imagePaths" :key="i">
                    <div class="image_fit" style="">
                        <div class="scroll_target" style="" :ref="'imgScrollTarget' + i">
                            <div :ref="'resizeTarget' + i"><img :src="$resourcePath + each" style="width:100%; background-color: black;" @load="detectImageLoad(i)"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="position:absolute; left :0px; width:100%; top:0px;background-color:rgba(0, 0, 0, 0.3);" :style="{height : $GlobalStore.statusBarHeight() ? $GlobalStore.statusBarHeight() + 'px' : '0px'}"></div>
        <div style="position:absolute; left :0px; width:100%; height:50px; display:flex; background-color:rgba(0, 0, 0, 0.3);" :style="{top : $GlobalStore.statusBarHeight() ? $GlobalStore.statusBarHeight() + 'px' : '0px'}">
            <div style="width:50px;display:grid;place-items: center;" @click="closeImageViewer"><img :src="require('@/assets/img/white_x_btn_new.png')" style="width:20px;"></div>
            <div style="flex:1; color:white;display:grid; place-items: center; font-weight:500;">사진</div>
            <div style="display:grid; place-items: center; color:white;width:50px; font-weight:500;">{{ curIndex + 1 }}/{{ imagePaths.length }}</div>
        </div>
    </div>
</template>

<script>
import ImageViewer from '@/modules/ImageViewer';

export default {
    name: "ImageViewer",
    props: {
        imagePaths: Array,
        initIndex: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            curIndex: 0,
            imageViewer: null
        }
    },
    methods: {
        closeImageViewer() {
            this.$GlobalStore.closeLastModal();
        },
        detectImageLoad(i) {
            this.imageViewer.init(this.$refs['resizeTarget' + i][0], this.$refs['imgScrollTarget' + i][0]);
        },
        detectIndexChange(i) {
            this.curIndex = i;
        }
    },
    mounted() {
        this.imageViewer = ImageViewer(this.$refs.transTarget, this.$refs.touchPanel);
        this.imageViewer.setDetectIndexChange(this.detectIndexChange)
        this.imageViewer.goToPage(this.initIndex);
        this.curIndex = this.initIndex;
    },
}
</script>

<style scoped>
.touch_panel {
    height: 100%;
    font-size: 0px;
    overflow: hidden;
    background-color: black;
    position: relative;
}

.trans_target {
    white-space: nowrap;
    height: 100%;
}

.image_wrap {
    width: 100%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
}

.scroll_target {
    display: inline-block;
    width: 100%;
    max-height: 100%;
    overflow: auto;
}

.image_fit {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
</style>